import { ButtonGroup, Card, CardBody, Col } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { ButtonHeading, VerticalTitle } from "../../../Constants/Constants";
import { VerticalText } from "../../../Data/ButtonsData/GroupButtonData";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { CommonDropdown } from "../Common/CommonDropdown";

export const VerticalButtonGroup = () => {
  return (
    <Col lg="6">
      <Card className="vertical-btn-group height-equal">
        <CommonCardHeader headClass="card-no-border pb-0" title={VerticalTitle} span={VerticalText} tag />
        <CardBody className="btn-group-wrapper">
          <ButtonGroup vertical>
            <Btn color="primary">{ButtonHeading}</Btn>
            <Btn color="secondary">{ButtonHeading}</Btn>
            <ButtonGroup>
              <CommonDropdown color="success" />
            </ButtonGroup>
            <Btn color="info">{ButtonHeading}</Btn>
            <Btn color="warning">{ButtonHeading}</Btn>
            <CommonDropdown color="danger" />
            <CommonDropdown color="light"/>
          </ButtonGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
